let agent = navigator.userAgent.toLowerCase();
let wasmEnabled = false;
let isSafari = agent.indexOf('safari') > -1 && agent.indexOf('chrome') == -1;
if (isSafari && parseFloat(agent.match(/ applewebkit\/(\d+)/)[1]) < 607) {
  wasmEnabled = false;
} else {
  wasmEnabled = true;
}

if (wasmEnabled && typeof WebAssembly == "object") {
  wasmEnabled = true;
} else {
  wasmEnabled = false;
}
export default function useWebAssembly() {
  if (!wasmEnabled) {
    return { wasmEnabled: false }
  }
  if (navigator.userAgent.indexOf("Edge") !== -1) {
    return { wasmEnabled: true, brotli: false }
  }
  return { wasmEnabled: true, brotli: true }
}